import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { linkService } from '../../services';
import { LinkType } from '../../types/misc';

export default function InviteRedirectPage(): JSX.Element {
  const { linkId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const invalidNavigate = (): void => {
    toast.error(t('toast.error.general.invalidInvite'));
    navigate('/');
  };

  useEffect(() => {
    if (!linkId) {
      invalidNavigate();
      return;
    }

    linkService
      .getLinkInfo(linkId)
      .then((linkInfo) => {
        console.log('Link info received:', linkInfo);

        if (!linkInfo) {
          invalidNavigate();
          return;
        }

        switch (linkInfo.type) {
          case LinkType.BUSINESS_INVITE:
          case LinkType.MOMENTS_INVITE:
          case LinkType.COMMUNITY_INVITE:
            navigate(`/moments/invite?invitationId=${linkId}`, { replace: true });
            break;
          case LinkType.CONNECTION_INVITE:
            navigate(`/invite?invitationId=${linkInfo.data?.linkId || linkId}`, { replace: true });
            break;
          case LinkType.PERSONAL_INVITE:
            navigate(`/personal/invite?token=${linkInfo.data?.linkId || linkId}`, { replace: true });
            break;
          case LinkType.PERSONAL_LINK:
            navigate(`/personalLink?linkId=${linkInfo.data?.linkId || linkId}`, { replace: true });
            break;
          case LinkType.EVENT_INVITE:
            navigate(`/event/invite?id=${linkInfo.data?.linkId || linkId}`, { replace: true });
            break;
          case LinkType.EVENT_DATEPICKER_INVITE:
            navigate(`/date-picker/invite?id=${linkInfo.data?.linkId || linkId}`, { replace: true });
            break;
          case LinkType.LOCAL_CONTACT:
          case LinkType.EXTERNAL_MEMBER_INVITE:
            navigate(
              `/moments/local-invite?token=${linkInfo.data?.linkId || linkId}${linkInfo.data?.eventId ? `&eventId=${linkInfo.data.eventId}` : ''}`,
              { replace: true },
            );
            break;
          default:
            console.log('Unknown link type:', linkInfo.type);
            invalidNavigate();
        }
      })
      .catch((error) => {
        console.error('Error fetching link info:', error);
        invalidNavigate();
      });
  }, []);

  return <></>;
}
